import {Axios} from '../axios/axios.js'
//任务列表
export const getTasksList = (e) => {
  return Axios({
    url:"/index.php/task/get_task_list",
    method:'put',
    data:e
  })
}
//司机列表
export const getDriverList = (e) => {
  return Axios({
    url:"/index.php/task/get_worker_list",
    method:'put',
    data:e
  })
}
//数据柱状图获取司机列表
export const getDriverListChart = (e) => {
  return Axios({
    url:"/index.php/Anylaze/get_anylaze_worker_list",
    method:'put',
    data:e
  })
}
//删除task
export const deleteTaskList  = (e) => {
  return Axios({
    url:'/index.php/task/del_task',
    method:'put',
    data:e
  })
}
//详情接口
export const tasksDetialList  = (e) => {
  return Axios({
    url:'/index.php/task/get_task_detail',
    method:'put',
    data:e
  })
}
//新增task接口
export const addNewTasksList  = (e) => {
  return Axios({
    url:'/index.php/task/add_task',
    method:'put',
    data:e
  })
}
//通过code 查地址
export const getCodeAddress = (e) => {
  return Axios({
    url:'/index.php/address/get_code_address',
    method:'put',
    data:e
  })
}
//编辑 或者复制时 调接口获取信息
export const getCopyMssage = (e) => {
  return Axios({
    url:'/index.php/task/get_task_info',
    method:'put',
    data:e
  })
}
//编辑
export const editTaskList = (e) => {
  return Axios({
    url:'/index.php/task/edit_task',
    method:'put',
    data:e
  })
}
//监听扫码枪

export const scanTask = (e) => {
  return Axios({
    url:'/index.php/task/scan_task',
    method:'put',
    data:e
  })
}
//修改 autocreate
export const autoCreate = (e) => {
  return Axios({
    url:'/index.php/user/change_autocreate',
    method:'put',
    data:e
  })
}
//获取所有省份
export const getAllProvice = () => {
  return Axios({
    url:'/index.php/public_data/get_data',
    method:'get',
  })
}
//修改任务状态
export const changeTaskStatus = (e) => {
  return Axios({
    url:"/index.php/task/add_task_log",
    method:'put',
    data:e
  })
}
//导出任务列表 Task/export_tasks
export const taskExport = (e) => {
  return Axios({
    url:"/Task/export_tasks",
    method:'put',
    data:e,
    responseType: 'blob'
  })
}
//新增note
export const addNote = (e) => {
  return Axios({
    url:"/task/add_task_note",
    method:'put',
    data:e,
  })
}
//删除note

export const deleteNote = (e) => {
  return Axios({
    url:"/task/del_task_note",
    method:'put',
    data:e,
  })
}
//更新任务开关 /task/update_task_switches
export const changeSwitch = (e) => {
  return Axios({
    url:"/task/update_task_switches",
    method:'put',
    data:e,
  })
}
